import React from 'react';
import { AlertTriangle } from 'lucide-react';

const FundingReadinessBlockers = ({ blockers = [] }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] p-4">
    <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-[var(--fg-text)]">
      <AlertTriangle className="size-4 text-amber-600" />
      Blockers
    </div>
    {blockers.length === 0 ? (
      <p className="text-sm text-[var(--fg-muted)]">No major blockers identified in this estimate.</p>
    ) : (
      <ul className="space-y-2">
        {blockers.map((item) => (
          <li key={item} className="rounded-lg border border-amber-200/70 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
            {item}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default FundingReadinessBlockers;
